import { http } from "@/utils/http";
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  User,
  UpdateUserRequest,
  ChangePasswordRequest,
  UserProfile,
  UpdateProfileRequest,
} from "@/types";

export const authApi = {
  // User login
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await http.post<any>(
      "/api/v1/users/login",
      credentials,
    );
    
    // Check if response is wrapped in ApiResponse format
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      return response.data.data;
    }
    
    return response.data;
  },

  // User registration
  async register(userData: RegisterRequest): Promise<User> {
    const response = await http.post<any>("/api/v1/users/register", userData);
    
    // Check if response is wrapped in ApiResponse format
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      return response.data.data;
    }
    
    return response.data;
  },

  // Get current user information
  async getCurrentUser(): Promise<User> {
    const response = await http.get<User>("/api/v1/users/me");
    
    // Check if response is wrapped in ApiResponse format
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      return (response.data as any).data;
    }
    
    return response.data;
  },

  // Get user profile information
  async getProfile(): Promise<UserProfile> {
    // Corrected path with /api prefix
    const response = await http.get<UserProfile>("/api/v1/users/profile");
    return response.data;
  },

  // Update user profile with new fields
  async updateProfile(userData: UpdateProfileRequest): Promise<UserProfile> {
    // Corrected path with /api prefix
    const response = await http.put<UserProfile>(
      "/api/v1/users/profile",
      userData,
    );
    return response.data;
  },

  // Update user profile (legacy)
  async updateUserProfile(userData: UpdateUserRequest): Promise<User> {
    // Corrected path with /api prefix
    const response = await http.put<User>("/api/v1/users/profile", userData);
    return response.data;
  },

  // Change password
  async changePassword(passwordData: ChangePasswordRequest): Promise<void> {
    // Corrected path with /api prefix
    await http.put("/api/v1/users/password", passwordData);
  },

  // Grant premium access after review submission
  async grantPremiumAccess(): Promise<User> {
    // Corrected path with /api prefix
    const response = await http.post<User>(
      "/api/v1/users/grant-premium-access",
    );
    return response.data;
  },

  // Resend email verification
  async resendVerificationEmail(email: string): Promise<void> {
    const encodedEmail = encodeURIComponent(email);
    await http.post(`/api/v1/users/resend-verification?email=${encodedEmail}`);
  },
};
